import React from "react";
import { Button, Group, Modal, Stack, Text } from "@mantine/core";

interface DisableCalendarConfirmModalProps {
  opened: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirms turning a staff member's bookable calendar OFF. The backend keeps
 * their staff_services and working hours across the toggle so reports keep
 * working — it only changes visibility and plan seat usage.
 */
export function DisableCalendarConfirmModal({
  opened,
  onCancel,
  onConfirm,
}: DisableCalendarConfirmModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title="Hide from calendar?"
      centered
    >
      <Stack>
        <Text size="sm">
          Removing the bookable calendar off of this staff member will prevent
          the user from accepting new bookings, editing existing bookings or
          checking out any incompleted services. The user will no longer
          contribute to your bookable calendar limits based on your plan.
        </Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancel}>
            Cancel
          </Button>
          <Button color="teal" onClick={onConfirm}>
            Hide from calendar
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
